import './App.scss';
import { Container, Navbar, Nav } from 'react-bootstrap';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom'
import Home from './routes/Home';
import Footer from './components/Footer';
import Intro from './routes/Intro';
import Detail from './routes/Detail';
import data from './soap';
import { useState } from 'react';
import Cart from './components/Cart';




function App() {
  let navigate = useNavigate();
  let location = useLocation();
  console.log(location)
  let [soap, setSoap] = useState(data);
  let [count, setCount] = useState(1);

  return (
    <div className="App">

      <Navbar collapseOnSelect expand="lg" className="bg-body-white">
        <Container>
          <Navbar.Brand onClick={() => { navigate('/') }} className='logo'></Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" className='phone' />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link onClick={() => { navigate('/main') }} className='nav'>제품 보기</Nav.Link>
              <Nav.Link href="#features" className='nav'>베스트셀러</Nav.Link>
              <Nav.Link href="#pricing" className='nav'>선물 추천</Nav.Link>
              <Nav.Link href="#pricing" className='nav'>매장 보기</Nav.Link>
              {/* <NavDropdown title="Dropdown" id="collapsible-nav-dropdown"> */}
              {/* <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item> */}
              {/* <NavDropdown.Item href="#action/3.2">
                Another action
              </NavDropdown.Item> */}
              {/* <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item> */}
              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item> */}
              {/* </NavDropdown> */}
            </Nav>
            <Nav>
              <Nav.Link href="#pricing" className='nav bold'>Shop in KR</Nav.Link>
              <Nav.Link onClick={() => { navigate('/cart') }} className='nav '>장바구니</Nav.Link>
              <Nav.Link eventKey={2} className='nav'>로그인</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Routes>

        <Route path='/main' element={<Home soap={soap} setSoap={setSoap} count={count} setCount={setCount} />} />
        <Route path='/detail/:id' element={<Detail soap={soap} />} />
        <Route path='/cart' element={<Cart />} />
        <Route path='/' element={<Intro />} />

      </Routes>
      {
        location.pathname === '/' ? null : <Footer />
      }


    </div>
  );
}

export default App;
